import React, { useState } from 'react';
import { Tabs, Tab, Box, Paper } from '@mui/material';
import GasPanel from './GasPanel';
import { empresasConfig } from './config';

const GasTabs = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Paper elevation={0} sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs 
          value={activeTab} 
          onChange={handleTabChange}
          sx={{
            '& .MuiTab-root': {
              fontSize: '1rem',
              fontWeight: 500,
              textTransform: 'none',
            },
            '& .Mui-selected': {
              color: (theme) => theme.palette.primary.main,
            },
            '& .MuiTabs-indicator': {
              backgroundColor: (theme) => theme.palette.primary.main,
            }
          }}
        >
          <Tab label="Hipergas" />
          <Tab label="Naturalgas" />
        </Tabs>
      </Paper>

      <GasPanel 
        empresa={empresasConfig.hipergas}
        isVisible={activeTab === 0}
      />
      
      <GasPanel 
        empresa={empresasConfig.naturalgas}
        isVisible={activeTab === 1}
      />
    </Box>
  );
};

export default GasTabs;